module.exports = __webpack_public_path__ + "static/media/26a.7d184b7e.jpg";